module.exports = __webpack_public_path__ + "static/media/reply_icon.0b8dd2dd.svg";